import { Card } from "antd";

export function Mention({ url, thumbnail, title }) {


  return (
    <>
      <div className="_f _fm _click"
        onClick={() => {
          window.open(url, '_blank');
        }}
      >

        <div
          className="angle"
          style={{
            backgroundImage: `url(${thumbnail})`,
            aspectRatio: '2 / 1',
            width: '6em',
            borderRadius: '0em',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }} />
        <div className="">
          <b>{title}</b>
        </div>
      </div>
    </>
  )
}
